import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/home.vue'
import { publicFn } from '@/utils'
import store from '@/store'

// 解决当前导航点击两次回报错
Vue.use(VueRouter)
// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

const routes = [
  {
    path: '/',
    redirect: 'addstudents'
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      title: '定位'
    }
  },
  {
    path: '/fence',
    name: 'fence',
    component: () => import('../views/home/fence.vue'),
    meta: {
      title: '围栏信息'
    }
  },
  {
    path: '/fenceAdd',
    name: 'fenceAdd',
    component: () => import('../views/home/fenceAdd.vue'),
    meta: {
      title: '围栏信息'
    }
  },
  {
    path: '/track',
    name: 'track',
    component: () => import('../views/home/track.vue'),
    meta: {
      title: '轨迹信息'
    }
  },
  {
    path: '/studentinfo',
    name: 'studentinfo',
    component: () => import('../views/bindinfo/studentinfo.vue'),
    meta: {
      title: '选择学生'
    }
  },

  {
    path: '/addstudents',
    name: 'addstudents',
    component: () => import('../views/bindinfo/addstudents.vue'),
    meta: {
      title: '添加学生'
    }
  },

  {
    path: '/addfamily',
    name: 'addfamily',
    component: () => import('../views/bindinfo/addfamily.vue'),
    meta: {
      title: '添加学生'
    }
  },

 

  {
    path: '/familyinfo',
    name: 'familyinfo',
    component: () => import('../views/bindinfo/familyinfo.vue'),
    meta: {
      title: '监护人信息'
    }
  },
  {
    path: '/familybind',
    name: 'familybind',
    component: () => import('../views/bindinfo/familybind.vue'),
    meta: {
      title: '监护人信息'
    }
  },
  {
    path: '/devicescan',
    name: 'devicescan',
    component: () => import('../views/bindinfo/devicescan.vue'),
    meta: {
      title: '监护人信息'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/login.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/student',
    name: 'student',
    component: () => import('../views/login/student.vue'),
    meta: {
      title: '选择学生'
    }
  },
  {
    path: '/attendance',
    name: 'attendance',
    component: () => import('../views/attendance/attendance.vue'),
    meta: {
      title: '考勤'
    }
  },
  {
    path: '/attendancetrack',
    name: 'attendancetrack',
    component: () => import('../views/message/attendancetrack.vue'),
    meta: {
      title: '考勤'
    }
  },
  {
    path: '/attendancetest',
    name: 'attendancetest',
    component: () => import('../views/attendance/attendancetest.vue'),
    meta: {
      title: '考勤'
    }
  },
  {
    path: '/my',
    name: 'my',
    component: () => import('../views/my/my.vue'),
    meta: {
      title: '设置'
    }
  },
  {
    path: '/recharge',
    name: 'recharge',
    component: () => import('../views/my/pay/recharge.vue'),
    meta: {
      title: '饭卡充值'
    }
  },
  {
    path: '/chargelist',
    name: 'chargelist',
    component: () => import('../views/my/pay/chargelist.vue'),
    meta: {
      title: '充值记录'
    }
  },
  {
    path: '/pay',
    name: 'pay',
    component: () => import('../views/my/pay/pay.vue'),
    meta: {
      title: '卡片缴费'
    }
  },
  {
    path: '/paylist',
    name: 'paylist',
    component: () => import('../views/my/pay/paylist.vue'),
    meta: {
      title: '缴费记录'
    }
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('../views/my/order/order.vue'),
    meta: {
      title: '消费记录'
    }
  },
  {
    path: '/sendmsglist',
    name: 'sendmsglist',
    component: () => import('../views/my/sendmsg/sendmsglist.vue'),
    meta: {
      title: '消息记录'
    }
  },
  {
    path: '/sendmsg',
    name: 'sendmsg',
    component: () => import('../views/my/sendmsg/sendmsg.vue'),
    meta: {
      title: '发送设备消息'
    }
  },
  {
    path: '/mute',
    name: 'mute',
    component: () => import('../views/my/mute.vue'),
    meta: {
      title: '静音时间段'
    }
  },
  {
    path: '/message',
    name: 'message',
    component: () => import('../views/message/message.vue'),
    meta: {
      title: '消息'
    }
  },
  {
    path: '/message-list',
    name: 'message-list',
    component: () => import('../views/message/message-list.vue'),
    meta: {
      title: '消息列表'
    }
  },
  {
    path: '/manual',
    name: 'manual',
    component: () => import('../views/my/manual.vue'),
    meta: {
      title: '产品手册'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/my/about.vue'),
    meta: {
      title: '关于我们'
    }
  },
  {
    path: '/hesuanqrcode',
    name: 'hesuanqrcode',
    component: () => import('../views/my/qrcode/hesuanqrcode.vue'),
    meta: {
      title: '核酸检测码'
    }
  },
  {
    path: '/healthqrcode',
    name: 'healthqrcode',
    component: () => import('../views/my/qrcode/healthqrcode.vue'),
    meta: {
      title: '健康码'
    }
  },
  {
    path: '/healthcode',
    name: 'healthcode',
    component: () => import('../views/my/healthcode.vue'),
    meta: {
      title: '健康防疫'
    }
  },
  {
    path: '/phone',
    name: 'phone',
    component: () => import('../views/my/phone.vue'),
    meta: {
      title: '通讯录'
    }
  },
  {
    path: '/guardian',
    name: 'guardian',
    component: () => import('../views/my/guardian.vue'),
    meta: {
      title: '通讯录'
    }
  },
  {
    path: '/leave',
    name: 'leave',
    component: () => import('../views/my/leave'),
    meta: {
      title: '请假'
    }
  },
  {
    path: '/leave-list',
    name: 'leave-list',
    component: () => import('../views/my/leave-list'),
    meta: {
      title: '请假记录'
    }
  },
  {
    path: '/attdetail',
    name: 'attdetail',
    component: () => import('../views/message/attdetail'),
    meta: {
      title: '消息'
    }
  },
  {
    path: '/addhomework',
    name: 'addhomework',
    component: () => import('../views/message/addhomework'),
    meta: {
      title: '提交作业'
    }
  },
  {
    path: '/success',
    name: 'success',
    component: () => import('../views/message/success'),
    meta: {
      title: '作业提交'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.afterEach((to, from) => {
  // window.__wxjs_is_wkwebview
    // true 时 为 IOS 设备
    // false时 为 安卓 设备
  let host = location.origin; //host
  if (window.__wxjs_is_wkwebview) {  // IOS
    if (window.entryUrl == '' || window.entryUrl == undefined) {
      
      var url = `${host}${to.fullPath}`
      //alert(url);
      window.entryUrl = url    // 将后面的参数去除
    }
    getWxAuth(to.fullPath,"ios")
  }else {       // 安卓 设置延迟 因为安卓有时候即时签名成功，但是仍然唤不起功能
    if (window.entryUrl == '' || window.entryUrl == undefined) {
      
      var url = `${host}${to.fullPath}`
      //alert(url);
      window.entryUrl = url    // 将后面的参数去除
    }
    setTimeout(function () {
      getWxAuth(host + to.fullPath,"android")
    }, 500);
  }
})

function getWxAuth() {
  
  
  // //请求签名信息 调用wx.config
  // this.$http
  // .json_post("/api/GetWXJSTicket",{
  //   url: window.entryUrl
  // }).then(data=>{
  //   if(data.code==0){
  //       alert(JSON.stringify(data));
  //       alert("appid:"+data.data.appid);
  //       alert("timestamp:"+data.data.timestamp);
  //       alert("nonceStr:"+data.data.nonceStr);
  //       alert("sign:"+data.data.sign);
  //       wx.config({
  //           debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
  //           appId: data.data.appid, // 必填，公众号的唯一标识
  //           timestamp: data.data.timestamp, // 必填，生成签名的时间戳
  //           nonceStr: data.data.nonceStr, // 必填，生成签名的随机串
  //           signature: data.data.sign,// 必填，签名
  //           jsApiList: ['getLocation','scanQRCode'] // 必填，需要使用的JS接口列表
  //       });
  //       wx.scanQRCode({
  //         desc: 'scanQRCode desc',
  //         needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
  //         scanType: ['barCode',"qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
  //         success: function (res) {
  //           alert(res.resultStr);
  //         },
  //         fail: err => { alert(JSON.stringify(err)) }
  //       });
        
  //   }else {
  //     Toast(data.msg);
  //   }
  // })
  // .catch(res=>{
  //   alert(JSON.stringify(res));
  // })

 //唤起对应功能 调用wx.ready
}


export default router
